import { isArrayNotEmpty, iTxt, SecurityGuard, useRedirect } from "@duosoftbg/nacid-components";
import React, { Fragment } from "react";
import { getI18n } from "react-i18next";
import styled from "styled-components";

const SectionTxt = styled.div`
  margin-bottom: 10px;
`;

const AdminConsoleLinkDiv = styled.div`
  margin-bottom: 10px;
`;

const AdminConsoleLink = styled.a`
  margin-left: 15px;
  color: ${(props) => props.theme.palette.primary.light};

  :hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const AdminConsolePageContent = ({ item }) => {
  const hasChildren = (children) => isArrayNotEmpty(children);
  const { redirect } = useRedirect();

  return (
    <Fragment>
      {hasChildren(item.children) ? (
        <>
          <SectionTxt> {iTxt(getI18n().language, item.title, item.titleEn)}</SectionTxt>
          <AdminPageChildrenContent items={item.children} />
        </>
      ) : (
        <AdminConsoleLinkDiv>
          <AdminConsoleLink onClick={() => redirect(item.href)}>
            {iTxt(getI18n().language, item.title, item.titleEn)}
          </AdminConsoleLink>
        </AdminConsoleLinkDiv>
      )}
    </Fragment>
  );
};

const AdminConsolePageContentRenderer = ({ item }) => {
  const accessRoles = item.accessRoles;
  if (accessRoles && accessRoles.length > 0) {
    return (
      <SecurityGuard checkForRoles={accessRoles} roleOperator={"or"}>
        <AdminConsolePageContent item={item} />
      </SecurityGuard>
    );
  }

  return <AdminConsolePageContent item={item} />;
};

const AdminPageChildrenContent = ({ items }) => {
  const hasChildren = (children) => isArrayNotEmpty(children);

  return (
    <>
      {hasChildren(items) &&
        items.map((item) => (
          <Fragment key={item.id}>
            <AdminConsolePageContentRenderer item={item} />
          </Fragment>
        ))}
    </>
  );
};

export default AdminPageChildrenContent;
